import React from 'react';
import useMetaTags from '../../hooks/useMetaTags';
// import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import { AssistanceSection, BenefitSection, BoostSection, CustomSection, FAQ, LargeData, ServicesSection, roleWriting } from '../../Data/All_Services_Data/seoConsultantData';
import Custom_section from '../../component/Services_Component/Custom_services_section';
import Benefits_section from '../../component/Services_Component/Benefits_section';
import Boost_section from '../../component/Services_Component/Boost_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';
import Role_writing from '../../component/Services_Component/Role_writing';
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const SEOConsultant = () => {
    useMetaTags({
      title:
        "SEO Consulting Services | Trusted Experts to Boost Your Website – Warrgyizmorsch",
      description:
        "Warrgyizmorsch offers expert SEO consulting services to help your site rank higher, attract more visitors, and achieve real growth online.",
      keywords:
        "seo consultant, search engine optimisation consultants, consulting seo, seo optimization consultants, seo consultant seo, seo consultant services, consultant seo services, seo service consultant, technical seo consultant, search optimization consultant, seo consulting",
    });
    return (
      <>
        <section
          className=""
          style={{
            backgroundImage: `url('assets/img/service/serviceD.jpg')`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          id="service-sec"
        >
          <div className="round-container pt-5">
            <div className="container">
              <div className="title-area text-center">
                <span className="sub-title text-white">OUR SERVICES</span>
                <h2 className="sec-title text-white">
                  SEO Consultant Services for Proven Results
                </h2>
              </div>
            </div>
          </div>
        </section>
        <section className="space-extra-bottom">
          <div className="page-single">
            <div className="page-content">
              <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
              {/* Intro part  */}
              <div
                className="header-section container"
                style={{ marginTop: "20px" }}
              >
                <img
                  src="assets/img/icon/seoConsultant.png"
                  loading="lazy"
                  alt="heading_image"
                />
                <div>
                  <p>
                    At Warrgyizmorsch our mission is to see your business grow
                    over the long term via our tailored SEO solutions. We know
                    that a strong online presence is key to growth which is why
                    we develop very specific strategies for each of our clients.
                    Our team does in depth audits, does extensive keyword
                    research and does what it takes in terms of technical SEO to
                    get your site in the best position it can be for search
                    engines which in turn increases traffic and sees more
                    conversions. With our help you will see real results which
                    position your business for sustained growth. We are
                    dedicated to building out your digital footprint SEO
                    consultant which in turn increases your online visibility.
                  </p>
                </div>
              </div>
              {/* How Our SEO Consulting Services Can Help You?  */}
              <Handle_Largedata_section LargeData={LargeData} />

              {/* The Importance of Hiring an SEO Consultant for Your Business */}
              <Custom_section data={CustomSection} />

              {/* Expand Your Digital Reach with Professional SEO Consulting  */}
              <Role_writing data={roleWriting} />

              {/* Why Trust Warrgyizmorsch for Your SEO Success?  */}
              <Boost_section data={BoostSection} />

              {/* FAQ section  */}
              <FAQ_section data={FAQ} />
            </div>
          </div>
        </section>
        <div className="scroll-top">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919",
              }}
            ></path>
          </svg>
        </div>
      </>
    );
};

export default SEOConsultant;